import React, { createContext, useContext } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';

interface NotificationContextProps {
  notify: (message: string, type: 'success' | 'error' | 'warn', links?: (string | { [text: string]: string })[]) => void;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const notify = (message: string, type: 'success' | 'error' | 'warn', links?: (string | { [text: string]: string })[]) => {
    const toastOptions = {
      className: type === 'success' ? 'success-toast' : type === 'error' ? 'error-toast' : 'warn-toast',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    };

    const messageContent = (
      <>
        {message}{' '}
        {links?.map((item, index) =>
          typeof item === 'string' ? (
            <Link key={index} to={item} className="toast-link">
              {item}
            </Link>
          ) : (
            Object.entries(item).map(([text, url]) => (
              <Link key={text} to={url} className="toast-link">
                {text}
              </Link>
            ))
          )
        )}
      </>
    );

    toast(messageContent, toastOptions);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <ToastContainer />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
